import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { ThermalPrintModule } from 'ng-thermal-print';
import { LfsaBotonEditarGridComponent } from '../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SharedModule } from '../../shared/shared.module';

import { ComedorRoutingModule } from './comedor-routing.module';
import { HomeComponent } from './views/home/home.component';
import { RegistroComidaComponent } from './views/registro-comida/registro-comida.component';
import { MantenerPreciosComponent } from './views/mantener-precios/mantener-precios.component';
import { MantenerProgramaNutricionComponent } from './views/mantener-programa-nutricion/mantener-programa-nutricion.component';


@NgModule({
    declarations: [
      HomeComponent,
      RegistroComidaComponent,
      MantenerPreciosComponent,
      MantenerProgramaNutricionComponent, //Feat: T30882 AppComedor Programa nutricional
    ],
    exports: [
      HomeComponent,
      RegistroComidaComponent,
      MantenerPreciosComponent,
      MantenerProgramaNutricionComponent,
    ],
    imports: [
      CommonModule,
      ComedorRoutingModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
      ThermalPrintModule
    ]
  })
export class ComedorModule {}